<template>
  <div class="content">
    <el-form :model="searchForm" label-width="100px" inline class="elform">
      <el-form-item label="插件名称">
        <el-input v-model="searchForm.name" clearable></el-input>
      </el-form-item>
      <el-form-item label="运行环境">
        <el-select v-model="searchForm.env" placeholder="请选择运行环境" clearable>
          <el-option label="测试环境" value="0"></el-option>
          <el-option label="正式环境" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-button type="primary" @click="loadData">查询</el-button>
      <el-button type="primary" @click="addPlugin">新增插件</el-button>
    </el-form>
    <!-- 表格 -->
    <el-table :data="tableData" style="margin: 10px 0 15px 0;" height="calc(100vh - 190px)" border size="small"
              :highlight-current-row="true">
      <el-table-column label="插件名称" prop="fName" align="center"></el-table-column>
      <el-table-column label="版本号" prop="fVersion" align="center"/>
      <el-table-column label="地址" width="600" prop="fPath" align="center"/>
      <el-table-column label="是否强制更新" prop="fForce" align="center" :formatter="(a,b,c)=>['否','是'][c]"/>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
        style="display:flex;justify-content: center"
        background
        layout="prev, pager, next"
        :page-count="page.count"
        :current-page.sync="page.page" @current-change="loadData"
        :page-size="page.pageSize"></el-pagination>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" top="60px">
      <el-form :model="currentRow" label-width="100px" :rules="rules" ref="addEditForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="插件名称" prop="name">
              <el-input v-model="currentRow.name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="版本号" prop="version">
              <el-input v-model="currentRow.version"></el-input>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="对象存储" prop="version">
              <el-select v-model="currentRow.storageId" placeholder="请选择" style="float: left">
                <el-option
                  v-for="item in storages"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="上传插件" required style="text-align: left">
              <el-upload ref="upload"
                         action=""
                         name="apk"
                         :file-list="fileList"
                         :multiple="false"
                         :auto-upload="false"
                         :on-change="fileChange"
              >
                <el-button type="success" slot="trigger" size="small">上传文件</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" v-if="optMode===optModeEnum.编辑">
            <el-form-item label="插件路径" prop="version">
              <el-input v-model="currentRow.path" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="运行环境" style="text-align: left">
              <el-select v-model="currentRow.env">
                <el-option label="正式环境" :value="'1'"></el-option>
                <el-option label="测试环境" :value="'0'"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="强制更新" style="text-align:left">
              <el-radio v-model="currentRow.force" :label="1">是</el-radio>
              <el-radio v-model="currentRow.force" :label="0">否</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="更新日志">
              <el-input v-model="currentRow.log" type="textarea" :rows="8" placeholder=""></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureOpt">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import {getPageList, addPlugin, updatePlugin, deletePlugin} from '../Service/pluginManage'
  import {list as getStorageList} from '../Service/storageManage'
  import _ from 'lodash'

  const row = {
    name: '',
    version: '',
    env: '0',
    force: 1,
    path: '',
    log: '',
    file: null,
    storageId: null,
  }
  export default {
    name: "pluginManage",
    data() {
      return {
        searchForm: {
          name: null,
          env: null,
        },
        tableData: [],
        page: {
          count: 0,
          page: 1,
          size: 15
        },
        optModeEnum: {
          '新增': 'add',
          '编辑': 'edit'
        },
        optMode: 'add',
        currentRow: _.cloneDeep(row),
        dialogFormVisible: false,
        fileList: [],
        storages:[],
        rules: {
          name: [
            {required: true, message: '请输入插件名称', trigger: 'blur'}
          ],
          version: [
            {required: true, message: '请输入版本号', trigger: 'blur'}
          ]
        }
      }
    },
    computed: {
      title() {
        return (this.optMode === this.optModeEnum.新增 ? '新增' : '编辑')
      }
    },
    mounted() {
      this.loadData()
    },
    methods: {
      loadData() {
        getStorageList().then(res=>{
          if (res.status === 'FAILURE') {
            this.$message.error(res.errorMessage)
          } else {
            this.storages = res.data
          }
        })
        const {page, size} = this.page
        const {name, env} = this.searchForm
        const params = {page, size, name: name === '' ? null : name, env: env === '' ? null : env}
        getPageList(params).then(res => {
          if (res.status === 'FAILURE') {
            this.$message.error(res.errorMessage)
          } else {
            this.tableData = res.data.list
            this.page.count = res.data.lastPage
          }
        })
      },
      fileChange(file) {
        console.log(file);
        this.currentRow.file = file.raw
        this.fileList = [file]
      },
      addPlugin() {
        this.optMode = this.optModeEnum.新增
        this.dialogFormVisible = true
        this.currentRow = _.cloneDeep(row)
        this.$nextTick(() => {
          this.$refs.upload.clearFiles()
        })
      },
      handleEdit(row) {
        this.optMode = this.optModeEnum.编辑
        const {fEnv: env, fForce: force, fId: id, fLog: log, fName: name, fPlatForm: platform, fVersion: version, fPath: path,storageId: storageId} = row
        this.currentRow = {env, force, id, log, name, platform, version, path,storageId}
        console.log(this.currentRow);
        this.dialogFormVisible = true
        this.$nextTick(()=>{
          this.$refs['addEditForm'].clearValidate()
        })

      },
      handleDelete(row) {
        this.$confirm(`确认删除插件【${row.fName}】?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          deletePlugin({id:row.fId}).then(() => {
            this.loadData()
          })
        })
      },
      sureOpt() {
        this.$refs['addEditForm'].validate((valid) => {
          if (!valid) return
          const {name, version, env, force, log, file, id,storageId} = this.currentRow
          const params = {name, version, env, force, log, file: file || null, id,storageId}
          const opt = (fn)=> {
            const loading = this.$loading({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
            fn(params).then((res) => {
              if(res.code!==200) return this.$message.error(res.message)
              this.dialogFormVisible = false
              this.loadData()
            }).catch(err=>{
              this.$message.error(err)
            })
              .finally(()=>{
              loading.close()
            })
          }
          if (this.optMode === this.optModeEnum.新增) {//新增版本
            if (this.$refs.upload.uploadFiles.length < 1) {
              return this.$message.error("请选择上传的APK文件");
            }
            opt(addPlugin)
          }
          else {
            opt(updatePlugin)
          }

        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .content {
    height: calc(100vh - 100px);
    width: calc(100vw - 40px);
    padding: 20px 20px 10px 20px;
    background-color: #fff;
    .elform {
      height: 50px;
      display: flex;
      align-items: center;
      .el-form-item {
        margin-bottom: 0;
      }
    }
  }
</style>
